import * as React from "react";
import "./showComments.scss";
import ListComment from "./ListComment";
import Loader from "../../../../../../components/Loader";
import { useDetailCommentsList } from "./hooks/useDetailCommentsList";
export default React.memo(function AutoGridNoWrap({ cardId }) {
  const { isCommentLoading, sortedComments } = useDetailCommentsList(cardId);

  return (
    <>
      {isCommentLoading ? (
        <div className="comment-loader">
          <Loader color={"black"} />
        </div>
      ) : (
        sortedComments.map(
          (data,index) => <ListComment key={`show-comment-item-${index}`} data={data} cardId={cardId} />
        )
      )}
    </>
  );
})
